import { render, staticRenderFns } from "./resource-search-suggestion.vue?vue&type=template&id=5d575ac8"
import script from "./resource-search-suggestion.vue?vue&type=script&lang=js"
export * from "./resource-search-suggestion.vue?vue&type=script&lang=js"
import style0 from "./resource-search-suggestion.vue?vue&type=style&index=0&id=5d575ac8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports